import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'grow_with_faire-top_nav_entrypoint-action_category_click';

/**
 * Triggered when a user clicks on the Holiday Spend Challenge entry point in the top navigation bar
 */
export function trackGrowWithFaireTopNavEntrypointActionCategoryClick(
  page_url: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { page_url },
  });
}
